<template>
    <div>
        <modal-add-service ref="addServiceDialog" :item="this.id"/>
        <modal-edit-service ref="editServiceDialog" :item="this.id"/>
        <data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            v-sortable-data-table
            @sorted="saveServiceOrder"
        >
            <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">
                            Czy na pewno chcesz usunąć tę usługę?
                        </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="onDeleteDialogClosed">
                                Anuluj
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="onDeleteConfirmed">
                                Tak
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
          <template v-slot:item.name="{ item }">
                <span v-if="item.carRental">
                  {{ item.name }}
                </span>
            <span v-else>
                  {{ item.type.name }}
                </span>
          </template>
            <template v-slot:item.category="{ item }">
                <span v-html="item.type.category"/>
            </template>
            <template v-slot:item.availableWithTransport="{ item }">
                <span>{{ item.availableWithTransport ? 'Tak' : 'Nie' }}</span>
            </template>
            <template v-slot:item.priceWithTransport="{ item }">
                <span v-if="item.carRental">
                  Ceny w zależności od długości wynajmu
                </span>
                <v-text-field
                    v-else-if="item.availableWithTransport"
                    v-model="item.priceWithTransport"
                    type="number"
                    v-bind:suffix="' zł'"
                ></v-text-field>
                <span v-if="!item.availableWithTransport"> - </span>
            </template>
            <template v-slot:item.availableWithoutTransport="{ item }">
                <span>{{ item.availableWithoutTransport ? 'Tak' : 'Nie' }}</span>
            </template>
            <template v-slot:item.priceWithoutTransport="{ item }">
                <v-text-field
                    v-if="item.availableWithoutTransport"
                    v-model="item.priceWithoutTransport"
                    type="number"
                    v-bind:suffix="item.unit + '/zł'"
                ></v-text-field>
                <span v-if="!item.availableWithoutTransport"> - </span>
            </template>
            <template v-slot:item.isActive="{ item }">
                <span>{{ item.isActive ? 'Tak' : 'Nie' }}</span>
            </template>
            <template v-slot:item.promoted="{ item }">
                <span>{{ item.promoted ? 'Tak' : 'Nie' }}</span>
            </template>
            <template v-slot:item.instant="{ item }">
                <span>{{ item.instant ? 'Tak' : 'Nie' }}</span>
            </template>
            <template v-slot:item.actions="{ item }"
                      class="text-end"
            >
                <v-btn
                    class="ma-2"
                    color="blue"
                    dark
                    :disabled="loading"
                    @click="onRowClicked(item, $event)"
                >
                    Edycja
                    <v-icon
                        dark
                        right
                    >
                        mdi-table-edit
                    </v-icon>
                </v-btn>
                <v-btn
                    class="ma-2"
                    color="red"
                    dark
                    :disabled="loading"
                    @click="onDeleteBtnTriggered(item, $event)"
                >
                    Usuń
                    <v-icon
                        dark
                        right
                    >
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
        </data-table>
        <div class="text-center">
            <v-btn
                class="mx-2"
                @click="showAddServiceModal()"
            >
                Dodaj nową usługę
            </v-btn>
            <v-btn
                class="mx-2"
                @click="refresh"
            >
                Odśwież
            </v-btn>
            <v-btn
                class="mx-2"
                @click="savePrices"
            >
                Zapisz ceny&nbsp;<v-icon size="24">mdi-content-save-outline</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import DataTable from "@/components/data-table/DataTable";
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import ModalAddService from "../ModalAddService";
import ModalEditService from "../ModalEditService";
import Sortable from "sortablejs";

export default {
    props: {
        id: {
            type: [String],
            required: true,
        },
        urlDelete: {
            type: [String],
            required: true,
        },
    },
    mixins: [
        filters,
        formatters,
    ],
    components: {
        ModalEditService,
        ModalAddService,
        DataTable,
    },
    data() {
        return {
            loading: false,
            items: [],
            total: 0,
            options: {},
            headers: [
                {text: 'Nazwa', value: 'name', sortable: false},
                {text: 'Kategoria', value: 'type.category', sortable: false},
                {text: 'Partner', value: 'partner.name', sortable: false},
                {text: 'Cena', value: 'priceWithTransport', sortable: false},
                {text: 'Aktywna', value: 'isActive', sortable: false},
                {text: 'Promowana', value: 'promoted', sortable: false},
                {text: 'Natychmiastowa', value: 'instant', sortable: false},
                {text: 'Akcje', value: 'actions', sortable: false, width: '275px'},
            ],
            filters: {},
            dialogDelete: false,
            editedIndex: -1,
            editedService: null,
        };
    },
    directives: {
        sortableDataTable: {
            bind(el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },
    created() {
        getDatatableParams.call(this);
        this.load();
    },
    mounted() {
        const self = this;

        this.$root.$on('loadPriceListCompanyServices', (options) => {
            self.load(options);
        });
    },
    watch: {
        options: {
            handler() {
                this.load();
                setDatatableOptions.call(this);
            },
            deep: true,
        },
        dialogDelete(value) {
            value || this.onDeleteDialogClosed();
        },
    },
    methods: {
        async showAddServiceModal() {
            this.$refs.addServiceDialog
                .open()
        },
        async showEditServiceModal(service) {
            const editedService = Object.assign({}, service);
            this.$refs.editServiceDialog
                .open(editedService)
        },
        appendFilters(params, filters) {
            if (!(filters instanceof Object)) {
                return;
            }

            this.appendStringFilterIfNonEmpty(params, 'branchName', filters.branchName);
        },
        delete(index) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            const item = this.items[index];

            api
                .delete(
                    this.$props.urlDelete.replace('{id}', item.id).replace('{branch}', this.id)
                )
                .then(() => {
                    this.items.splice(index, 1);
                    this.total--;

                    if (!this.items.length) {
                        this.options.page--;
                    }

                    this.onDeleteDialogClosed();
                    this.$root.$emit('notifySuccess', {
                        html: `Usługa została usunięta.`,
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się usunąć oddziału.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.dialogDelete = true;
        },

        load(options = {}) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            options = options || {};

            api.get(`/api/price-list/company-branch/${this.id}/service`)
                .then((response) => {
                    this.items = response.data.items;
                    this.total = response.data.total;

                    if (options.onSuccess) {
                        options.onSuccess();
                    }
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać usług.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        refresh() {
            const self = this;
            this.$root.$emit('loadPriceListCompanyServices', {
                onSuccess: () => {
                    self.$root.$emit('notify', {
                        html: 'Lista została odświeżona.',
                    });
                }
            });
        },
        savePrices() {

            let data = [];

            this.items.forEach(service => {
                data.push({
                    'id': service.id,
                    'availableWithTransport': service.availableWithTransport,
                    'availableWithoutTransport': service.availableWithoutTransport,
                    'priceWithTransport': service.priceWithTransport === "" ? null : parseFloat(service.priceWithTransport),
                    'priceWithoutTransport': service.priceWithoutTransport === "" ? null : parseFloat(service.priceWithoutTransport),
                })
            });

            api
                .put('/api/price-list/company-branch/' + this.id + '/service/price', {services: data})
                .then(() => {
                    this.load();
                    this.$root.$emit('notifySuccess', {
                        html: 'Ceny zostały zapisane',
                    });
                })
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        stopRowClickPropagation(event) {
            // The following line is required to avoid triggering onRowClicked() method.
            event.cancelBubble = true;
            event.stopPropagation();
        },
        onDeleteBtnTriggered(item, event) {
            this.stopRowClickPropagation(event);
            this.deleteItem(item);
        },
        onDeleteConfirmed() {
            this.delete(this.editedIndex);
        },
        onDeleteDialogClosed() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
            });
        },
        onRowClicked(service) {
            this.showEditServiceModal(service);
        },
        saveServiceOrder(event) {
            const movedItem = this.items.splice(event.oldIndex, 1)[0];
            this.items.splice(event.newIndex, 0, movedItem);

            let request = [];

            this.items.forEach((field, index) => {
                request.push({
                    id: field.id,
                    position: index,
                });
            });

            api
                .put('/api/price-list/company-branch/' + this.id + '/service/position', {fields: request})
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
    },
}
</script>